function t(t){if("object"==typeof t)return Object.assign({},t);const n=function(...n){return t.apply(this,n)};for(let e in t)t.hasOwnProperty(e)&&(n[e]=t[e]);return n}export{t as cloneFunction,t as default};
